<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-toolbar-items style="height: 100%">
    <v-btn
      icon
      large
      @click="dialog=true"
    >
      <v-icon>mdi-web</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="300px"
      scrollable
    >
      <v-card
        :dark="isDarkMode"
        :light="!isDarkMode"
        class="py-2"
      >
        <v-list>
          <v-list-item
            v-for="item in allLocales"
            :key="item.langCode"
            @click="setLocale(item.langCode)"
          >
            <v-list-item-avatar>
              <flag-icon
                :flag="item.flag"
                class="mt-2"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="text-body-2">{{ item.label }}</span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <div
                v-if="currentLocale === item"
              >
                <v-icon>
                  mdi-bookmark-check
                </v-icon>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-toolbar-items>
</template>

<script>
import FlagIcon from '../commonDecoration/FlagIcon.vue'

export default {
  name: 'LanguageSwitcher',
  components: {
    FlagIcon
  },
  props: {
    locales: {},
    currentLocaleCode: {},
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    currentLocale () {
      return Object.values(this.locales).find(it => it.langCode === this.currentLocaleCode)
    },
    allLocales () {
      return Object.values(this.locales).filter(el => el.langCode !== this.currentLocale)
    }
  },
  methods: {
    setLocale (locale) {
      this.$emit('language-change', locale)
      this.dialog = false
    }
  }
}
</script>

<style>
</style>
